interface Props {
  onClick?: () => void;
  className?: string;
}

export default function IconS(props: Props) {
  const { onClick, className } = props;

  return (
    <div 
      onClick={onClick}
      className={className}
    >
      <span>S</span>
    </div>
  );
}